import { useEffect } from "react";
import { api } from "@/lib/api";

/**
 * Fires a single POST /api/visits per browser session.
 * Mounted once at the App root. Failures are silent.
 */
export default function VisitTracker() {
  useEffect(() => {
    const KEY = "bda_visit_pinged_v1";
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem(KEY)) return;
    api.post("/visits").catch(() => {}).finally(() => {
      try { sessionStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    });
  }, []);
  return null;
}
